import { Component, OnInit } from '@angular/core';
import { Ticket } from './ticket';
import * as html2canvas from "html2canvas";
import { Message } from 'primeng/api';
import { TicketService } from './ticket.service';
import { ErrorHandler } from "../utils/error-handler"
import { MessagesService } from '../messages/messages.service';

@Component({
    selector: 'ticket-dialog',
    templateUrl: './ticket.component.html',
    styleUrls: ['./ticket.component.css']
})

export class TicketComponent implements OnInit {

    defaultTimeout = 600000;
    url: string;
    ticket: Ticket;
    display: boolean = false;
    fileToBeUploaded: File;
    fromEmail: string;
    subject: string;
    description: string;
    errorHandler: ErrorHandler = new ErrorHandler;
    msgs: Message[] = [];

    constructor(private _ticketService: TicketService, private messagesService: MessagesService) {
    }

    ngOnInit() {
        this.ticket = new Ticket();
    }

    showDialog() {
        this.fromEmail = "";
        this.subject = "";
        this.description = "";
        this.ticket.fileToBeUploaded = null;
        this.display = true;
    }

    isDisabled() {
        return this.isUndefindedOrEmpty(this.fromEmail) ||
            this.isUndefindedOrEmpty(this.subject) ||
            this.isUndefindedOrEmpty(this.description);
    }

    submit() {
        this.ticket.fromEmail = this.fromEmail;
        this.ticket.subject = this.subject;
        this.ticket.description = this.description;
        // console.log("Ticker Details", this.ticket);

        this._ticketService.createTicket(this.ticket).subscribe(
            success => {
                this.msgs = [];
                this.msgs.push({ severity: 'success', summary: 'Ticket created successfully', detail: '' });
                this.closeDialogWindow();
            },
            error => {
                this.msgs = [];
                let errMessage = this.errorHandler.handleError(error);
                this.messagesService.addErrorMessage(errMessage);
                //this.msgs.push({ severity: 'error', summary: 'We are facing issue creating this ticket', detail: '' })
            }
        );
    }

    screenshot() {
        //this.closeDialogWindow();
        (html2canvas as any)(document.body).then(canvas => {

            let imgData = canvas.toDataURL("image/jpeg", 1.0);
            this.ticket.fileToBeUploaded = imgData;
            this.msgs.push({ severity: 'success', summary: 'Screenshot Taken Successfully', detail: '' })
            //document.body.appendChild(canvas);
        });

        // this.display = true;
    }

    closeDialogWindow() {
        this.display = false;
    }

    isUndefindedOrEmpty(fieldVale: string) {
        return fieldVale === undefined || fieldVale.length == 0;
    }


}